var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { RefetchIntervals } from '#constants';
import { useLucidSdk } from '#context';
import { toWorkspaceViewModel } from '#models';
import { WorkspacesKeyFactory } from '../../query-key-factories';
import { canFetchWorkspaceData } from '../../services';
import { useGetWorkspaceLoginStatus } from './useGetWorkspaceLoginStatus';
export function useWorkspaceByIdPoll(workspaceId) {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { query: { data: workspaceLoginStatus }, } = useGetWorkspaceLoginStatus(workspaceId);
    const query = useQuery({
        queryKey: WorkspacesKeyFactory.byWorkspacePoll(workspaceId),
        queryFn: () => lucidSdk.workspacesManagement().getWorkspace(workspaceId),
        enabled: canFetchWorkspaceData(workspaceLoginStatus),
        networkMode: 'always',
        refetchInterval: ({ state }) => {
            const isOnboardingPending = state.data && state.data.isOnboardingCompleted == false;
            const wasDataUploaded = state.data && state.data.hasDataBeenUploadedToAnyFilespace;
            return !wasDataUploaded && isOnboardingPending
                ? RefetchIntervals.l
                : false;
        },
        select: toWorkspaceViewModel,
    });
    return { query };
}
_react_refresh_temp_1(useWorkspaceByIdPoll, "SbdBs5aIiaIFSyvdNoid7gLUPcs=", false, () => [useLucidSdk, useGetWorkspaceLoginStatus, useQuery]);
